import { generateClient } from "aws-amplify/api";
import { create } from "zustand";
import { getSearchHistory as getSearchHistoryQuery } from "@/graphql/queries";
import type { SearchHistoryItem } from "@/API";

const client = generateClient();

type SearchBarState = {
  searchHistoryItem: SearchHistoryItem[];
};

export const searchHistoryState = create<SearchBarState>(() => ({
  searchHistoryItem: [],
}));

export const getSearchHistory = async () => {
  try {
    const { data } = await client.graphql({
      query: getSearchHistoryQuery,
    });

    if (data.getSearchHistory)
      searchHistoryState.setState({
        searchHistoryItem: data.getSearchHistory as SearchHistoryItem[],
      });
  } catch {
    // Pass
  }
};
